(function () {
  angular
    .module('specsguardApp')
    .directive('sgHideableSidenav', sgHideableSidenav);

  function sgHideableSidenav () {
    return {
      restrict: 'A',
      link: function (scope, element, attributes) {
        let jqLiteElement;
        const getJqLiteElement = () => {
          if (!jqLiteElement) {
            jqLiteElement = angular.element(element);
          }
        };

        const deregisterOpenListener = scope.$on('openActivitySidenav', () => {
          getJqLiteElement();
          jqLiteElement.addClass('sg-open');
        });

        const deregisterCloseListener = scope.$on('closeActivitySidenav', () => {
          getJqLiteElement();
          jqLiteElement.removeClass('sg-open');
        });

        scope.$on('$destroy', () => {
          deregisterOpenListener();
          deregisterCloseListener();
        });
      }
    };
  }
})();
